import { ArrowBack, ArrowForward } from '@material-ui/icons';
import React from 'react';
import PrimaryButton from '../../../components/UI/PrimaryButton';
import { useHistory } from 'react-router';
import AuthRoutes from '../../configs/auth.route';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../../../hooks/useLocale';

const BackToLoginBtn = ({ title }: { title?: string }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const { isArabic } = useLocale();
  return (
    <PrimaryButton
      isFullWidth
      variant="outline"
      className="border-none"
      title={title ?? t('common.back_to_login')}
      leadingIcon={isArabic ? <ArrowForward /> : <ArrowBack />}
      onClick={() => history.replace(AuthRoutes.LOGIN)}
    />
  );
};

export default BackToLoginBtn;
